import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class TabButton extends Component {

	render() {
		return (
			<div
				className={classNames(this.props.className,
					{
						'tab-link': true,
						[this.props.activeClass]: this.props.isActive,
					})}
				onClick={this.props.onClick}
			>
				{this.props.children}
			</div>
		)
	}
}

TabButton.defaultProps = {
	onClick: () => {},
}

TabButton.propTypes = {
	isActive: PropTypes.bool,
	activeStyle: PropTypes.object,
	firstLink: PropTypes.bool,
	style: PropTypes.object,
	children: PropTypes.node,
	className: PropTypes.string,
	activeClass: PropTypes.string,
}

export default TabButton
